// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__31mBc","colCheckbox":"styles_colCheckbox__27m1l"};